import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/_shared/shared.service';
import { RepService } from '../../services/rep.service';
import { Reservation } from '../../models/reservation';
import { toServerDateTime } from 'src/app/_shared/date-utils';

@Component({
  selector: 'app-reservation-list',
  templateUrl: './reservation-list.component.html',
  styleUrls: ['./reservation-list.component.scss']
})
export class ReservationListComponent implements OnInit {
  reservations: Reservation[] = [];
  /** True po prvním dokončeném loadu — rozlišuje „načítá se" vs „prázdný seznam". */
  reservationsLoaded = false;
  totalCount = 0;
  page = 1;
  pageSize = 20;
  Math = Math;

  // Filters
  filters: {
    status: string;
    vehicle_type: string;
    date_from: Date | null;
    date_to: Date | null;
  } = {
    status: '',
    vehicle_type: '',
    date_from: null,
    date_to: null
  };

  statusOptions = [
    { value: '', label: 'Všechny' },
    { value: 'PENDING', label: 'Čeká na potvrzení' },
    { value: 'CONFIRMED', label: 'Potvrzeno' },
    { value: 'CANCELLED', label: 'Zrušeno' },
    { value: 'COMPLETED', label: 'Dokončeno' }
  ];

  vehicleTypeOptions = [
    { value: '', label: 'Všechny' },
    { value: 'PERSONAL', label: 'Osobní' },
    { value: 'TRUCK', label: 'Nákladní' }
  ];

  constructor(
    private repService: RepService,
    private router: Router,
    private shared: SharedService
  ) { }

  ngOnInit(): void {
    this.loadReservations();
  }

  async loadReservations(): Promise<void> {
    try {
      const params: any = {
        paginator: {
          limit: this.pageSize,
          offset: (this.page - 1) * this.pageSize,
          orderBy: 'date_from',
          orderDir: 'DESC'
        }
      };

      // Apply filters
      if (this.filters.status) params.status = this.filters.status;
      if (this.filters.vehicle_type) params.vehicle_type = this.filters.vehicle_type;
      if (this.filters.date_from) params.date_from = toServerDateTime(this.filters.date_from);
      if (this.filters.date_to) params.date_to = toServerDateTime(this.filters.date_to);

      const result = await this.repService.getReservations(params);
      this.reservations = Reservation.fromArray(result?.rows || []);
      this.totalCount = result?.count || 0;
      this.reservationsLoaded = true;
    } catch (error) {
      this.shared.reportError(error, 'Error loading reservations');
    }
  }

  applyFilters(): void {
    this.page = 1;
    this.loadReservations();
  }

  clearFilters(): void {
    this.filters = {
      status: '',
      vehicle_type: '',
      date_from: null,
      date_to: null
    };
    this.page = 1;
    this.loadReservations();
  }

  onPageChange(page: number): void {
    this.page = page;
    this.loadReservations();
  }

  createReservation(): void {
    this.router.navigate(['/reservations/new']);
  }

  viewReservation(id: number): void {
    this.router.navigate(['/reservations', id]);
  }

  formatDateTime(date: Date | string | null | undefined): string {
    if (!date) return '';
    const d = date instanceof Date ? date : new Date(date);
    return d.toLocaleString('cs-CZ', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  getStatusClass(status: string): string {
    const classes: Record<string, string> = {
      'PENDING': 'badge-warning',
      'CONFIRMED': 'badge-success',
      'CANCELLED': 'badge-danger',
      'COMPLETED': 'badge-secondary'
    };
    return classes[status] || 'badge-secondary';
  }

  getStatusLabel(status: string): string {
    const labels: Record<string, string> = {
      'PENDING': 'Čeká',
      'CONFIRMED': 'Potvrzeno',
      'CANCELLED': 'Zrušeno',
      'COMPLETED': 'Dokončeno'
    };
    return labels[status] || status;
  }
}
